import {
  downloadCouponPathCheckQueryOption,
  useCustomQuery,
} from 'src/hooks/react-query/useCustomQuery.hook'
import { DownloadCouponPathCheckSpace } from 'src/types/api'
import RenderIf from 'src/components/common/RenderIf'
import { Loading } from 'src/components/common/Loading'
import React from 'react'
import { QueryClient } from '@tanstack/react-query'
import { Params } from 'react-router-dom'
import useParamsType, { MatchParams } from 'src/hooks/useParamsType.hook'
import DownloadCouponPageView from 'src/pages/DownloadCouponPage/view'

export interface DownloadCouponPageProps {
  downloadCouponData?: DownloadCouponPathCheckSpace.Response
}

export const downloadCouponPageLoader =
  (queryClient: QueryClient) =>
  async ({ params: { idx }, request }: { params: Params<keyof MatchParams>; request: Request }) => {
    return Promise.allSettled([
      await queryClient.ensureQueryData(
        downloadCouponPathCheckQueryOption({ Idx: Number(idx!), ImgPath: request.url }),
      ),
    ])
  }

const DownloadCouponPage = () => {
  const { idx } = useParamsType()

  const { data: downloadCouponCheckData, isLoading: isDownloadCouponCheckLoading } =
    useCustomQuery<DownloadCouponPathCheckSpace.Response>(
      downloadCouponPathCheckQueryOption({ Idx: Number(idx), ImgPath: window.location.href }),
    )

  const props: DownloadCouponPageProps = {
    downloadCouponData: downloadCouponCheckData?.Body,
  }

  return (
    <React.Fragment>
      <RenderIf when={isDownloadCouponCheckLoading}>
        <Loading.Default />
      </RenderIf>
      <DownloadCouponPageView {...props} />
    </React.Fragment>
  )
}

export default DownloadCouponPage
